const stringToBoolean = string => {
  if (!string) throw new Error('the stringToBoolean param must to be a string');

  const accepteds = {
    true: ['true', 'yes', '1'],
    false: ['false', 'no', '0'],
  };

  string = String(string).toLowerCase();

  return accepteds.true.includes(string)
    ? true
    : accepteds.false.includes(string)
    ? false
    : Boolean(string);
};

export default stringToBoolean;
